import { handleErrors } from "@/utils/handle-errors";
import { SdkConfigurationEnvironment } from "@/interfaces/sdk-configuration-environment";
import fetch from "@mv/flow-shared-utils/functions/fetch";
export const saveConfigurationEnvironment = (configurationEnvironment: SdkConfigurationEnvironment) => ({
  type: "saveConfigurationEnvironment",
  configurationEnvironment,
});
export const updateConfigurationEnvironment = (configurationEnvironment: SdkConfigurationEnvironment) => ({
  type: "updateConfigurationEnvironment",
  configurationEnvironment,
});
export const loadAllConfigurationEnvironment = (configurationenvironmentId: number) => ({
  type: "loadAllConfigurationEnvironment",
  configurationenvironmentId,
});
export const loadConfigurationEnvironment = (configurationenvironmentId: number) => ({
  type: "loadConfigurationEnvironment",
  configurationenvironmentId,
});
export const deleteConfigurationEnvironment = (configurationenvironmentId: number) => ({
  type: "deleteConfigurationEnvironment",
  configurationenvironmentId,
});

export const actions = {
  loadAllConfigurationEnvironment(context: any, { configurationenvironmentId }: { configurationenvironmentId: number }) {
    return fetch(`core/api/configuration/environment/${configurationenvironmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  loadConfigurationEnvironment(context: any, { configurationenvironmentId }: { configurationenvironmentId: number }) {
    return fetch(`core/api/configuration/${configurationenvironmentId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  deleteConfigurationEnvironment(context: any, { configurationenvironmentId }: { configurationenvironmentId: number }) {
    return fetch(`core/api/configuration/${configurationenvironmentId}`, {
      method: "DELETE",
    });
    // .then(handleErrors);
    // .then((data) => data);
  },

  saveConfigurationEnvironment(
    state: any,
    // tslint:disable-next-line:align
    { configurationEnvironment }: { configurationEnvironment: SdkConfigurationEnvironment }
  ) {
    return fetch(`core/api/configuration`, {
      method: "POST",
      body: JSON.stringify(configurationEnvironment),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateConfigurationEnvironment(
    state: any,
    // tslint:disable-next-line:align
    { configurationEnvironment }: { configurationEnvironment: SdkConfigurationEnvironment }
  ) {
    return fetch(`core/api/configuration`, {
      method: "PUT",
      body: JSON.stringify(configurationEnvironment),
    })
      .then(handleErrors)
      .then((data) => data);
  },
};
